import { integrationsRequest } from '../lib/integrations';
import { eventMeetingLink } from '../lib/meetingLinks';
import { outlookDateTime } from '../lib/calendarDates';

export async function getMeetings() {
  try { return await integrationsRequest('/api/meetings'); }
  catch (error) {
    if (error.status === 404) {
      error.code = 'meetings/backend-unavailable';
      error.message = 'The connected server does not have the meeting agent yet. Deploy the latest SPCC API and scheduler, then check the connection again.';
    }
    throw error;
  }
}
export const scheduleMeeting = input => integrationsRequest('/api/meetings', { body: input });
export const getMeeting = id => integrationsRequest(`/api/meetings/${id}`);
export const stopMeeting = id => integrationsRequest(`/api/meetings/${id}/stop`, { body: {} });
export const retryMeeting = id => integrationsRequest(`/api/meetings/${id}/retry`, { body: {} });
export const recoverMeeting = (id, botId) => integrationsRequest(`/api/meetings/${id}/recover`, { body: { bot_id: botId } });
export const analyzeMeeting = id => integrationsRequest(`/api/meetings/${id}/analyze`, { body: {} });
export const routeMeetingItem = (id, itemId) => integrationsRequest(`/api/meetings/${id}/items/${itemId}/route`, { body: {} });

export function calendarMeetings(events, source, now = Date.now()) {
  return events.flatMap(event => {
    if (!event.id || event.isAllDay || event.isCancelled || event.status === 'cancelled' || event.responseStatus?.response === 'declined' ||
        event.attendees?.some(a => a.self && a.responseStatus === 'declined')) return [];
    const link = eventMeetingLink(event);
    const start = source === 'google' ? new Date(event.start?.dateTime || NaN) : outlookDateTime(event.start);
    if (!link || !Number.isFinite(start.getTime()) || start.getTime() < now) return [];
    return [{ title: event.summary || event.subject || 'Meeting notes', meeting_url: link.url, platform: link.platform,
      join_at: start.toISOString(), calendar_source: source, calendar_event_id: event.id }];
  }).sort((a, b) => a.join_at.localeCompare(b.join_at));
}

export async function loadCalendarMeetings(service, source) {
  const connection = source === 'google' ? service.googleService : service.outlookService;
  await connection.initialize();
  if (!connection.isAuthenticated) throw new Error(`Connect ${source === 'google' ? 'Google Calendar' : 'Outlook'} first.`);
  const start = new Date(), end = new Date(start.getTime() + 7 * 86400000);
  return calendarMeetings(await connection.getEvents(start, end), source, start.getTime());
}
